import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Kimlik doğrulama httpOnly oturum çerezi ile yapılır (XSS koruması):
// token JavaScript'e hiç dokunmaz; tarayıcı çerezi her istekte otomatik gönderir.
export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Geçici ağ kopmalarına (ERR_CONNECTION_RESET vb.) dayanıklılık:
// yanıt alınamayan GET istekleri kısa beklemeyle 2 kez otomatik yeniden denenir.
const bekle = (ms) => new Promise((coz) => setTimeout(coz, ms));
api.interceptors.response.use(undefined, async (err) => {
  const cfg = err?.config;
  const iptal = axios.isCancel(err) || err?.code === "ERR_CANCELED"; // bilinçli iptal — yeniden deneme
  const agHatasi = !err?.response; // sunucudan hiç yanıt yok (bağlantı sıfırlandı / zaman aşımı)
  if (!cfg || iptal || !agHatasi || (cfg.method || "get").toLowerCase() !== "get") {
    return Promise.reject(err);
  }
  cfg.__denemeSayisi = (cfg.__denemeSayisi || 0) + 1;
  if (cfg.__denemeSayisi > 2) return Promise.reject(err);
  await bekle(700 * cfg.__denemeSayisi);
  return api(cfg);
});

// API hata mesajı çıkarıcı (400 string / 422 dizi)
export const getErrMsg = (err, fallback = "Bir hata oluştu.") => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return fallback;
};
